import UnipileContext from 'src/contexts/unipileContext'
import { useContext } from 'react'

export default function useUnipileContext() {
  const contextValues = useContext(UnipileContext)

  if (!contextValues)
    throw new Error(
      'useUnipileContext must be used within a UnipileContextProvider wrapped around the App'
    )

  return contextValues
}
